import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=35d760ba&scoped=true"
import script from "./auth.vue?vue&type=script&lang=js"
export * from "./auth.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/auth/auth.scss?vue&type=style&index=0&id=35d760ba&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d760ba",
  null
  
)

export default component.exports